import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './assets/css/common.scss';
import Vant from 'vant';
import 'vant/lib/index.css';
import 'lib-flexible/flexible';
import mixin from './assets/js/mixin';
import api from './api/index';

Vue.config.productionTip = false;
Vue.mixin(mixin);
Vue.use(Vant);
Vue.prototype.$api = api;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
